import { MetadatiRepertorioDTO } from "./metadati-repertorioDTO";

export class NotaDaSostituireDTO {
  id: string;
  oggetto: string;
  dataApprovazione: string;
  metadatiRepertorio: MetadatiRepertorioDTO;
}
